import React from "react";
import { Tooltip } from "@mui/material";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import {
  CHILI_AVATAR_PALETTE,
  CHILI_BRAND_COLORS,
} from "../../constants/chiliBrandColors.ts";

type Employee = {
  id: number;
  person: {
    firstName: string;
    lastName: string;
    secondLastName?: string;
  };
};

const EmployeeInitialsAvatars = ({
  employees,
  maxVisible = 10,
}: {
  employees: Employee[];
  maxVisible?: number;
}) => {
  if (!employees?.length) return null;

  const visible = employees.slice(0, maxVisible);
  const overflow = employees.length - maxVisible;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 6,
        marginTop: 0,
      }}
    >
      {visible.map((employee, index) => {
        const palette =
          CHILI_AVATAR_PALETTE[index % CHILI_AVATAR_PALETTE.length];
        const initials = `${employee.person.firstName?.charAt(0) || ""}${
          employee.person.lastName?.charAt(0) || ""
        }`.toUpperCase();
        const fullName = toCamelCase(
          `${employee.person.firstName} ${employee.person.lastName} ${
            employee.person.secondLastName || ""
          }`
        );

        return (
          <Tooltip title={fullName} arrow key={employee.id}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                backgroundColor: palette.bg,
                color: palette.text,
                fontSize: 10,
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 3px rgba(21, 34, 93, 0.15)",
                flexShrink: 0,
                cursor: "default",
              }}
            >
              {initials}
            </div>
          </Tooltip>
        );
      })}
      {overflow > 0 && (
        <Tooltip
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              {employees
                .slice(maxVisible)
                .map(
                  (e) =>
                    `• ${toCamelCase(`${e.person.firstName} ${e.person.lastName}`)}`
                )
                .join("\n")}
            </span>
          }
          arrow
        >
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: CHILI_BRAND_COLORS.varoBlue,
              color: "#ffffff",
              fontSize: 10,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(21, 34, 93, 0.15)",
              flexShrink: 0,
            }}
          >
            +{overflow}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default EmployeeInitialsAvatars;
